// Whether a local clock time falls within the user's ±3-hour wake window.
// Circular distance keeps the comparison correct across midnight.
export function isInMorningWeightWindow(wakeTime, now = new Date()) {
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(String(wakeTime || ""));
  if (!match) return false;
  const wakeMinutes = Number(match[1]) * 60 + Number(match[2]);
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  const direct = Math.abs(nowMinutes - wakeMinutes);
  return Math.min(direct, 1440 - direct) <= 180;
}
